import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { PaymentDialogComponent } from './payment-dialog/payment-dialog.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { PaymentSearchComponent } from './payment-search/payment-search.component';
import { AchOverviewComponent } from './ach-overview/ach-overview.component';
import { AchDetailComponent } from './ach-detail/ach-detail.component';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { AchTransactionDialogComponent } from './ach-transaction-dialog/ach-transaction-dialog.component';
import { AchRequestDetailComponent } from './ach-request-detail/ach-request-detail.component';
import { PaymentCreditsComponent } from './payment-credits/payment-credits.component';
import { BulkEditAchTransactionDialogComponent } from './bulk-edit-ach-transaction-dialog/bulk-edit-ach-transaction-dialog.component';
import { ApplyCreditDialogComponent } from './apply-credit-dialog/apply-credit-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'payments',
                component: BasicLayoutComponent,
                children: [
                    { path: 'search', component: PaymentSearchComponent, data: { title: 'Payments' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'ach-overview', component: AchOverviewComponent, data: { title: 'ACHs' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'history', component: PaymentHistoryComponent, data: { title: 'Payment History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'credits', component: PaymentCreditsComponent, data: { title: 'Credits' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'ach/:id', component: AchDetailComponent, data: { title: 'ACH Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                    { path: ':id', component: PaymentDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                    {
                        path: ':id/:dealerId/:selectedInvoiceId',
                        component: PaymentDetailComponent,
                        data: { title: 'Payment Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'ach/:id/:dealerId/:selectedInvoiceId',
                        component: AchRequestDetailComponent,
                        data: { title: 'ACH Request Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [
        PaymentDialogComponent,
        PaymentSearchComponent,
        PaymentHistoryComponent,
        AchOverviewComponent,
        AchDetailComponent,
        PaymentDetailComponent,
        AchTransactionDialogComponent,
        BulkEditAchTransactionDialogComponent,
        AchRequestDetailComponent,
        PaymentCreditsComponent,
        ApplyCreditDialogComponent,
    ],
})
export class PaymentsModule {}
